<template>
  <Button
    class="AnnouncementContentButton"
    type="primary"
    size="extra-small"
    @click="$emit('click')"
  >
    <slot />
  </Button>
</template>

<script>
import Button from '~/aasgard/components/buttons/Button.vue'

export default {
  name: 'AnnouncementContentButton',
  components: { Button },
  props: {
    variant: {
      type: String,
      default: 'purple',
      validator(value) {
        return ['purple', 'green', 'orange'].includes(value)
      },
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.AnnouncementContentButton {
  &.purple {
    background: $color-brand-primary;
  }

  &.green {
    background: $color-feedback-positive;
  }

  &.orange {
    background: #ff6f3f;
  }
}
</style>
